/* eslint-disable max-len */
export const Home = "/";
export const ResetPasswordHomepage = "/Homepage/ResetPassword";
export const HomeLogin = "/zaloguj";
export const HomeRegistration = "/rejestracja";
export const HomeChangeLocation = "/lokalizacja";
export const ValidateEmail = { url: "/user/validateEmail/%7BEmailChangeLogId%7D", type: undefined as { EmailChangeLogId: string | number; } };
export const Homepage = { url: "/homepage/%7Baction%7D", type: undefined as { action: string | number; } };
